import React from 'react';
import * as Styled from './Container.styled';
import { ContainerProps } from './Container.type';

const Container = ({
  size = 'm',
  isPadded = true,
  ...rest
}: ContainerProps) => {
  return <Styled.Container size={size} isPadded={isPadded} {...rest} />;
};

export { Container };
